import React from "react";
import { useState, useEffect } from "react";
import AxiosInstance from "../../services/AxiosInstance";
import {
  RESOLVER_GROUP_BY_TICKET_CATEGORY_URL,
  RESOLVER_BY_RG_URL,
  TICKET_ASSIGN_USER_URL,
} from "../../Constants/Constants";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { fetchData } from "../../services/UtilService";
import Tooltip from "@mui/material/Tooltip";
import { useAlert } from "./../alerts/AlertContext";
import {
  createTheme,
  IconButton,
  useTheme,
  ThemeProvider,
} from "@mui/material";
import { isEmpty, ROLE_USER } from "../../Constants/RolesConstants";
import { STATUS_OPEN } from "../../Constants/StatusConstants";

function AssignTicket({
  mergeTicketsDataIds,
  callTickets,
  getTickets,
  componentPermissions,
  userRole,
}) {
  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {},
  });

  const mergeTicketsData = getTickets(mergeTicketsDataIds);
  const [resolverGroupId, setResolverGroupId] = useState("");
  const [resolverGroups, setResolverGroups] = useState([]);

  const [resolverId, setResolverId] = useState("");
  const [categoryId, setCategoryId] = useState();
  const [resolvers, setResolvers] = useState([]);
  const [open, setOpen] = useState(false);

  const showAlert = useAlert();
  const [error, setError] = useState(false);

  const [formData, setFormData] = useState({
    resolverGroup: "",
    resolver: "",
  });

  const [formErrors, setFormErrors] = useState({
    resolverGroup: "",
    resolver: "",
  });

  const handleFormData = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const errors = {};

    if (!formData.resolverGroup)
      errors.resolverGroup = "Resolver Group is required";
    if (!formData.resolver) errors.resolver = "Resolver is required";

    return errors;
  };

  useEffect(() => { }, []);

  const handleClickOpen = () => {
    const allCatHaveSameId = mergeTicketsData.every(
      (item) => (item.ticketCategoryId === mergeTicketsData[0].ticketCategoryId && item.status === STATUS_OPEN)
    );
    if (mergeTicketsData.length === 0) {
      showAlert("Please select atleast one ticket", "error");
    } else if (!allCatHaveSameId) {
      showAlert("Please select same category and Open status tickets", "error");
    } else {
      setCategoryId(mergeTicketsData[0].ticketCategoryId);
      fetchData(
        `${RESOLVER_GROUP_BY_TICKET_CATEGORY_URL}/${mergeTicketsData[0].ticketCategoryId}`
      )
        .then((data) => setResolverGroups(data))
        .catch((err) => console.log("Failed to fetch data"));

      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleResolverGroupChange = (event) => {
    setResolverGroupId(event.target.value);
    handleFormData(event);

    // if(ticket?.resolverGroup?.id) {
    //   ticket.resolverGroup.id = event.target.value;
    // } else {
    //     ticket.resolverGroup = {id:''};
    //     ticket.resolverGroup.id = event.target.value;
    // }

    console.log("resolver url:" + RESOLVER_BY_RG_URL + event.target.value);
    AxiosInstance.get(`${RESOLVER_BY_RG_URL}/${event.target.value}`).then(
      (response) => setResolvers(response.data)
    );
  };

  const handleResolverChange = (event) => {
    setResolverId(event.target.value);
    handleFormData(event);
    // if(ticket?.resolver?.id) {
    //   ticket.resolver.id = event.target.value;
    // } else {
    //     ticket.resolver = {id:''};
    //     ticket.resolver.id = event.target.value;
    // }
  };

  const assignTickets = () => {
    const errors = validate();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      setError(false);

      var tkt = {};
      tkt.resolverGroupId = resolverGroupId;
      tkt.resolverId = resolverId;
      const ids = mergeTicketsData.map((item) => item.id);
      tkt.tickets = ids;

      AxiosInstance.post(TICKET_ASSIGN_USER_URL, tkt)
        .then((response) => {
          if (response.data) {
            showAlert(
              "Tickets assigned successfully to " + tkt.mergeTicket + " !",
              "success"
            );
          } else {
            showAlert("Tickets assgin failed !", "error");
          }
          callTickets();
        })
        .catch((error) => {
          showAlert("Tickets assgin failed !", "error");
          console.error(error);
        });
      handleClose();
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        {/* <Button variant="outlined" onClick={handleClickOpen} style={{float:"right", margin:"2px"}}>
              Add Ticket
              </Button> */}
        {userRole === ROLE_USER ? null : (
          <Tooltip
            title="Assign Ticket"
            onClick={handleClickOpen}
            style={{ cursor: "pointer", margin: "2px" }}
          >
            <IconButton>
              <PersonAddAlt1Icon color="primary" />
            </IconButton>
          </Tooltip>
        )}

        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: {
              width: 300, // fixed width
              height: 300, // fixed height
              maxWidth: "100%", // optional for responsiveness
              maxHeight: "100%", // optional to prevent overflow
            },
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              assignTickets();
              //handleClose();
            },
          }}
        >
          <DialogTitle>Assign Ticket</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
              noValidate
              autoComplete="off"
            >
              <FormControl
                variant="standard"
                sx={{ m: 1, minWidth: "100%" }}
                required
                error={Boolean(formErrors.resolverGroup)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Resolver Group
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={formData.resolverGroup}
                  name="resolverGroup"
                  onChange={handleResolverGroupChange}
                  label="Resolver Group"
                >
                  {resolverGroups.map((rg) => (
                    <MenuItem value={rg.id}>{rg.name}</MenuItem>
                  ))}
                </Select>
                {error && (
                  <FormHelperText>{formErrors.resolverGroup}</FormHelperText>
                )}
              </FormControl>

              <FormControl
                variant="standard"
                sx={{ m: 1, minWidth: "100%" }}
                required
                error={Boolean(formErrors.resolver)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Resolver
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={formData.resolver}
                  name="resolver"
                  onChange={handleResolverChange}
                  label="Resolver"
                >
                  {resolvers.map((res) => (
                    <MenuItem value={res.id}>{res?.name}</MenuItem>
                  ))}
                </Select>
                {error && (
                  <FormHelperText>{formErrors.resolver}</FormHelperText>
                )}
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default AssignTicket;
